class CartNotification extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    console.debug('Header',this.header)
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {


            const rendered = this.getSectionInnerHTML(
                parsedState.sections[section.id],
                section.selector
            )

            if( rendered ){
                document.getElementById(section.id).innerHTML = rendered
                return
            }

            console.error(
                `Couldn't replace section with rendered content!` +
                `Cannot find '${ section.selector }' in '${ section.id }'`)
      }));

      console.log('Header',this.header,document.querySelector('sticky-header'))

      this.header?.reveal()

      this.open();
  }

  getSectionsToRender() {

    const itemKey = this.cartItemKey

    return [
      {
        id: 'cart-notification-product',
        selector: `
            [id="cart-notification-product-${itemKey}"],
            [id*="cart-notification-product-${itemKey?.split(':')[0]}"]
        `,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {

    const dom = new DOMParser()
        .parseFromString(html,'text/html')

    return dom.querySelector(selector)
      ?.innerHTML
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
